import { render, staticRenderFns } from "./SMSWallet.vue?vue&type=template&id=08b6e820&scoped=true&"
import script from "./SMSWallet.vue?vue&type=script&lang=js&"
export * from "./SMSWallet.vue?vue&type=script&lang=js&"
import style0 from "./SMSWallet.vue?vue&type=style&index=0&id=08b6e820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6e820",
  null
  
)

export default component.exports